import React, {Component} from 'react';
import _ from 'lodash';
import {Col, Card, CardHeader, CardBody, Table} from "reactstrap";
import {gdsc_api_base_url} from "../../../settings";
import {api_base_url} from "../../../settings";
import Deserialiser from 'deserialise-jsonapi'
import Loading from '../../dumb/loading'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import filterFactory, {
    textFilter,
} from 'react-bootstrap-table2-filter';

import ExportCSVButton from '../../dumb/fancyTable/ExportCSVButton'
import ExportXLSXButton from '../../dumb/fancyTable/ExportXLSXButton'
import {paginationOptions} from '../../dumb/fancyTable/Pagination'
import ColumnHeader from "../../dumb/fancyTable/columnHeader";

const des = new Deserialiser();

class DrugData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drug_data: null,
            drug_data_loaded: false,
            model: props.model
        };

        this.load_drug_data = this.load_drug_data.bind(this)
    }

    load_drug_data() {
        let model = this.state.model;
        const model_id = this.state.model.id;
//         let cosmic_id_obj = _.filter(model.identifiers, id => {
//             return id.source.name === 'COSMIC_ID';
//         });
// 
//         if (_.isEmpty(cosmic_id_obj)) {
//             this.setState({drug_data: null, link: null});
//             return
//         }

        //let cosmic_id = cosmic_id_obj[0].identifier;

        //const drug_data_url = gdsc_api_base_url + '/api/drugs_response?cosmic_id=' + cosmic_id;
        const drug_data_url = `${api_base_url}/models/${model_id}/nlmes?include=drug&fields[drug]=drug_name,putative_target&page[size]=0&sort=z_score`

        fetch(drug_data_url)
            .then(response => response.json())
            .then(resp_obj => des.deserialise(resp_obj))
            .then(drugs => {
                //if (drugs.link) {
                    //this.props.setDrugLink( gdsc_api_base_url + drugs.link);
                    this.setState({
                        drug_data: drugs,
                        drug_data_loaded: true
                    });
                //} else {
                    //this.setState({
                       // drug_data: null,
                       // link: null,
                        //drug_data_loaded: true,
                    //});
                //}
            }).catch(function (ex) {
            console.log('parsing failed', ex);
        });

    }
    
    renderTable() {
    
//     <tr>
//                                 <th>Drug Name<br /><small>&nbsp;</small></th>
//                                 <th>Drug Targets<br /><small>&nbsp;</small></th>
//                                 <th>IC50 (μM)<br /><small>&nbsp;</small></th>
//                                 <th>Z Score<br /><small>&nbsp;</small></th>
//                                 <th>Dataset<br /><small>&nbsp;</small></th>
//                             </tr>
//                             </thead>
//                             <tbody>{_.map(this.state.drug_data, drug => {
//                             console.log("drug")
//                             console.log(drug)
//                                 return (
//                                     <tr key={drug.drug_id}>
//                                         <td>{drug.drug.drug_name}</td>
//                                         <td>{drug.drug.putative_target}</td>
//                                         <td>{drug.ln_ic50}</td>
//                                         <td>{drug.z_score}</td>
//                                         <td>GDSC2</td>
//                                     </tr>)
//                             })}


        const columns = [
            {
                dataField: 'drug.drug_name',
                text: "Drug Name",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                sort: true,
                tooltipText: "Drug Name"
            }, {
                dataField: 'drug.putative_target',
                text: "Drug Targets",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                sort: true,
                tooltipText: "Drug Targets"
            }, {
                dataField: 'ln_ic50',
                text: "IC50 (μM)",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                sort: true,
                tooltipText: "IC50 (μM)",
                formatter: (cell) => {
                    if (cell == null || isNaN(cell)) return '';
                    const micromolar = Math.exp(cell);
                    return micromolar.toPrecision(3);
                }
            }, {
                dataField: 'z_score',
                text: "Z Score",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                sort: true,
                tooltipText: "Z Score",
                formatter: (cell) => Number(cell).toPrecision(3)
            }
        ];

        return (

            <ToolkitProvider
                keyField="id"
                data={this.state.drug_data}
                columns={columns}
                exportCSV={{fileName: `CMP_${this.state.model.names[0]}_drugs.csv`}}
            >
                {
                    props => (
                        <div>
                            <div className="d-flex justify-content-left">
                                <b>Note:&nbsp;</b>Displays drug sensitivity data from the GDSC2 dataset.
                            </div>
                            <div className="d-flex justify-content-end">
                                <ExportCSVButton {...props.csvProps} />
                                <ExportXLSXButton data={this.state.drug_data} filename={`CMP_${this.state.model.names[0]}_drugs`} />
                            </div>
                            <BootstrapTable
                                {...props.baseProps}
                                bootstrap4
                                hover
                                keyField='id'
                                bordered={false}
                                pagination={this.state.drug_data.length > 5 ? paginationFactory(paginationOptions(5, this.state.drug_data.length)) : null}
                                filter={filterFactory()}
                                tableHeaderClass="border-top-none"
                            />
                        </div>
                    )
                }
            </ToolkitProvider>


        )
    }

    componentDidMount() {
        this.load_drug_data()
    }
    componentDidUpdate() {
        if (this.state.model.id !== this.props.model.id) {
            this.setState({model: this.props.model, drug_data_loaded: false}, this.load_drug_data)
        }
    }
    
    render() {
        if (!this.state.model.drugs_available) return null;

        let content = null;


        if (!this.state.drug_data_loaded) {
            content = (
                <div className="py-5"><Loading subtitle="Loading Drug Data"/></div>);
        } else {
            content = this.renderTable()
        }
        return (
            <Col className="my-3" lg={(this.state.activeColumns > this.wideBoxThreshold) ? 12 : 6}
                 xl={(this.state.activeColumns > this.wideBoxThreshold) ? 12 : 6}>
                <Card className="flex-fill drugs">
                    <CardHeader>Drug Sensitivity</CardHeader>

                    <CardBody>
                        {content}
                    </CardBody>
                </Card>
            </Col>
        );
    }

//     render() {
//         if (!this.state.drug_data_loaded || this.state.drug_data == null) {
//             return null;
//         }
//         return (
//             <Col className="my-3 d-flex" md={6}>
//                 <Card className="flex-fill drugs">
//                     <CardHeader>Drug Sensitivity</CardHeader>
//                     <CardBody className="card-body">
//                         <p>
//                             Top-5 drugs with lowest z-score
//                         </p>
//                         <div className="table-responsive">
//                         <Table>
//                             <thead>
//                             <tr>
//                                 <th>Drug Name<br /><small>&nbsp;</small></th>
//                                 <th>Drug Targets<br /><small>&nbsp;</small></th>
//                                 <th>IC50 (μM)<br /><small>&nbsp;</small></th>
//                                 <th>Z Score<br /><small>&nbsp;</small></th>
//                                 <th>Dataset<br /><small>&nbsp;</small></th>
//                             </tr>
//                             </thead>
//                             <tbody>{_.map(this.state.drug_data, drug => {
//                             console.log("drug")
//                             console.log(drug)
//                                 return (
//                                     <tr key={drug.drug_id}>
//                                         <td>{drug.drug.drug_name}</td>
//                                         <td>{drug.drug.putative_target}</td>
//                                         <td>{drug.ln_ic50}</td>
//                                         <td>{drug.z_score}</td>
//                                         <td>GDSC2</td>
//                                     </tr>)
//                             })}
//                             </tbody>
//                         </Table>
//                         </div>
//                     </CardBody>
//                 </Card>
//             </Col>
//         );
//     }
}

export default DrugData;
